// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".language-create[data-v-88a9e852] {\n  max-width: 720px;\n  margin-top: 16px;\n}\n.language-code-input[data-v-88a9e852] {\n  width: 220px;\n}\n", ""]);
// Exports
module.exports = exports;
